import React, { Component } from 'react'
import disableScroll from 'disable-scroll';
import VisibilitySensor from 'react-visibility-sensor'
import {getLanguage} from "../actions/commands";
import Footer from "../components/footer";


const ComponentHOC = (WrappedComponnet) => {
    return class ComponentHOC extends Component {
        constructor(props){
            super(props)
            this.state = {
                loaded: false,
                screenWidth: null
            }
            this.changeHandler = this.changeHandler.bind(this)
            this.updateDimensions = this.updateDimensions.bind(this)
        }

        componentWillMount() {
            this.updateDimensions();
        }
        componentWillUnmount() {
            window.removeEventListener("resize", this.updateDimensions);
        }
        updateDimensions(){
            this.setState({
                screenWidth: document.getElementsByTagName('body')[0].clientWidth
            })
        }

        componentDidMount(){
            document.getElementsByTagName('body')[0].style.overflow = "hidden";
            document.getElementsByTagName('body')[0].style.position = "unset";
            document.getElementsByTagName('html')[0].style.overflow = "hidden";
            document.getElementsByTagName('html')[0].style.position = "unset";
            disableScroll.on()
            this.setState({
                loaded: false
            })
            window.addEventListener("resize", this.updateDimensions);
        }
        changeHandler(isVisible) {
            var _self = this
            setTimeout(function(){
                _self.setState({
                    loaded: true
                })
                disableScroll.off()
                document.getElementsByTagName('body')[0].style.overflow = "auto";
                document.getElementsByTagName('body')[0].style.position = "relative";
                document.getElementsByTagName('html')[0].style.overflow = "auto";
                document.getElementsByTagName('html')[0].style.position = "relative";
            }, 1000)

        }
        render (){
            const {screenWidth, loaded} = this.state
            return(
                <div>
                    <VisibilitySensor onChange={this.changeHandler} >
                        {
                            (isVisible) => {
                                return isVisible?<WrappedComponnet {...this.props} screenWidth={screenWidth}/>:<div></div>
                            }
                        }
                    </VisibilitySensor>
                    <div className={`loading ${loaded?'':'show'}`}>
                        <div className="loader">Loading...</div>
                        <p>{getLanguage() === 'pt-br'?'Carregando...':'Loading...'}</p>
                        <Footer/>
                    </div>
                </div>
            )
        }
    }
}

export default ComponentHOC


// WEBPACK FOOTER //
// ./src/hoc/ComponentHOC.js